<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { Checklist, ItemDefinition, WorkflowDefinition } from "~/api";
import { useMyInfoStore } from "~/stores/MyInfoStore";
import { apiClient } from "~/utils/apiClient";

const complianceItem = defineModel<ItemDefinition>();

const emit = defineEmits(["update:modelValue"]);

const associatedChecklists = ref<Checklist[]>();
const associatedWorkflows = ref<WorkflowDefinition[]>();

const myInfoStore = useMyInfoStore();

onMounted(async () => {
  if (!complianceItem.value || !complianceItem.value.guid) {
    return;
  }

  associatedChecklists.value =
    await apiClient.itemDefinition.getAssociatedChecklists(
      complianceItem.value.guid,
      myInfoStore.currentSysOrgGuid,
    );

  associatedWorkflows.value =
    await apiClient.itemDefinition.getAssociatedWorkflows(
      complianceItem.value.guid,
      myInfoStore.currentSysOrgGuid,
    );
});
</script>

<template>
  <div v-if="complianceItem" class="compliance-item-usage">
    <section class="section usage">
      <h3>Associated Checklists</h3>
      <el-table :data="associatedChecklists" height="250" style="width: 100%">
        <el-table-column prop="name" label="Name">
          <template #default="{ row }">
            <span type="primary">
              {{ row.name }}
            </span>
            <span class="guidDisplay">({{ row.guid.substring(0, 8) }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="Created" />
        <el-table-column prop="updatedAt" label="Updated" />
      </el-table>
      <h3>Associated Workflows</h3>
      <el-table :data="associatedWorkflows" height="250" style="width: 100%">
        <el-table-column prop="name" label="Name">
          <template #default="{ row }">
            <span type="primary">
              {{ row.name }}
            </span>
            <span class="guidDisplay">({{ row.guid.substring(0, 8) }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="Created" />

        <el-table-column prop="updatedAt" label="Updated" />
      </el-table>
    </section>
  </div>
</template>

<style lang="less">
.compliance-item-usage {
  .el-dialog__body {
    display: grid;
    grid-gap: 15px;
  }
  .my-header {
    display: flex;
    justify-content: space-between;
  }
  .section {
    .dialogEdit {
      display: grid;
      grid-template-columns: 0.5fr 2fr 0.5fr;
      align-items: center;
      gap: 0.5em;
      padding-bottom: 0.5em;
    }

    .guidDisplay {
      font-size: 0.8em;
      color: var(--el-color-primary-light-3);
      margin-left: 2em;
      white-space: nowrap;
      > span {
        margin-right: 0.25em;
      }
    }
  }

  table {
    width: 100%;
    td {
      padding: 0.5em;
      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>
